import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ApplicationHostTypeService } from '../services/application-host-type.service';

@Directive({
  selector: '[boiApplicationHostType]'
})
export class ApplicationHostTypeDirective implements OnInit {
  private readonly boCssClass = 'bo';
  constructor(
    private readonly hostElement: ElementRef,
    private readonly renderer: Renderer2,
    private readonly applicationHostTypeService: ApplicationHostTypeService
  ) {}

  ngOnInit(): void {
    let propositionInterfaceCssClasses = this.applicationHostTypeService.getPropositionInterfaceCssClasses();
    if (propositionInterfaceCssClasses.length === 0) {
      propositionInterfaceCssClasses = [this.boCssClass];
    }

    propositionInterfaceCssClasses.forEach((propositionInterfaceCssClass) => {
      this.renderer.addClass(this.hostElement.nativeElement.parentElement, propositionInterfaceCssClass);
    });
  }
}
